import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DiscreteSliderValues from './DiscreteSliderValues';
import ClientProvider from './client';
export default createDemo(import.meta.url, DiscreteSliderValues, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/discrete-values/DiscreteSliderValues.tsx",
    "fileName": "DiscreteSliderValues.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function DiscreteSliderValues() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Slider\n        aria-label=\"Restricted values\"\n        defaultValue={20}\n        getAriaValueText={valuetext}\n        step={null}\n        valueLabelDisplay=\"auto\"\n        marks={marks}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 40,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function DiscreteSliderValues() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Slider\n        aria-label=\"Restricted values\"\n        defaultValue={20}\n        getAriaValueText={valuetext}\n        step={null}\n        valueLabelDisplay=\"auto\"\n        marks={marks}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slider"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Restricted values",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "20"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaValueText"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "valuetext"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "step"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-n",
                "null"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "valueLabelDisplay"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "auto",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "marks"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "marks"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 40,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
